import React from 'react'
import { useIntl } from 'react-intl'
import { ModalBody } from 'mailup-web-components'

export const PanelContentImmediate = () => {
  const intl = useIntl()

  return (
    <>
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.Schedulation.SendTypeSequenzialeText'
          })}
        </p>
      </ModalBody>
    </>
  )
}
